import * as React from "react";
import { useHistory } from "react-router-dom";
import { Modal as ModalStrap } from 'reactstrap';
import { useAuth } from "../../../Services/AuthContext";
import ResetPasswordPanel from "./ResetPasswordPanel";


const ResetPassword = () => {
    const [authUser] = useAuth();
    let history = useHistory();
    const onClose = () => {
        authUser.jwt ? history.goBack():history.push('/login')
    }
    const s = authUser.jwt ? null : { width: '100vw', height: '100vh', backgroundImage: "url(/img/Light-Jet.jpg)" };
    return <div style={s}>
        <ModalStrap isOpen={true} size="md" contentClassName="transparentmodal" centered>
            <h1>Reset!</h1><ResetPasswordPanel onClose={onClose} />
        </ModalStrap>
    </div>
}

export default ResetPassword;